// default imports for react project
import React, { useLayoutEffect } from "react";

// import for dispatching action in react

// import default style component from react-bootstrap package
import { Col, Container, Row } from "react-bootstrap";

// import function from actions
import { addCrumb } from "store/actions/common";

// import util to get current window dimensions
import useWindowDimensions from "utils/useWindowDimension";

// import stylesheet
import Style from "./fastfacts.module.css";

// import classname package to combine module css and normal css
import classNames from "classnames";

// Import icon from assets folder
import { card_header_img } from "assets/images/images";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { setParam } from "utils/utils";


//   import custom component
import { BlackArrayText } from "components/Heading";
import BreadCrumb from "components/Breadcrumb";
import BodyButton from "components/Buttons/BodyButton";
import CardHeader from "components/Card/CardHeader";
import { H4Red } from "components/Heading";
import { H1Grey } from "components/Heading";
import { H2Grey } from "components/Heading";

// React functional component starts here..
function FastFacts() {
  // initialized dispatch using react hook
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const currentToken =  useSelector(state => state.auth.currentUserToken)

  // react layout hook to perform initial layout operations
  useLayoutEffect(() => {
    // dispatching an action to update breadcrumb
    dispatch(addCrumb([{ link: "/fast-facts", name: "Fast Facts" }]));
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Get width from util
  const { width } = useWindowDimensions();

  function parseQuery(queryString) {
    var query = {};
    var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split('=');
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  }
 

  useEffect(() => {
    dispatch({type:"CURRENT_USER_TOKEN", payload:parseQuery(location.search).token ?? currentToken})
  },[])

  
  useEffect(() => {
    setParam(history,currentToken)
  },[currentToken])


  return (
    <Container>
      <BreadCrumb />
      <Row className={classNames("mt-5")}>
        <H1Grey>
          <span className="text-danger">SureThing</span> Fast Facts
        </H1Grey>
        <H2Grey>Covered by Experts</H2Grey>
      </Row>
      <Row className="mt-5">
        <Col lg={6} className={classNames("")}>
          <CardHeader disableButton={true} image={card_header_img} title="Cover" />
        </Col>
        <Col className={Style.fbutton}>
          <BodyButton
            color="white"
            bg="#DA291C"
            name="Get Cover Now"
            size={20}
            marginL={0}
            weight={700}
            marginT={width > 770 ? 0 : 20}
            black={width > 770 ? false : true}
            link="/forms"
            id="fast-facts-cover-button"
          />
        </Col>
        <Col lg={3} className={classNames(Style.money, width <770 && 'mt-3')}>
          <div className={Style.money}>
            Premium: <span className="text-danger"> &nbsp;R 1 000 pm</span>
          </div>
        </Col>
       
      </Row>
      <Row className={classNames(Style.topcard, "mt-3")}>
        <Row>
          <H4Red className="mt-4">Numbers worth noting:</H4Red>
          <Row  style={{marginLeft: '1vw'}}>
            <ul className="pl-4 mt-3">
              <li> There is a R 2,5 million limit on individual claims, with an annual aggregate cap of R 5 million.</li>
              <li>Statutory defence costs and legal representation costs for regulatory enquiries, including POPIA, and workplace vaccine disputes are limited to R 250 000 for each claim and R1 million in the annual aggregate.</li>
              <li>Excess: R 10 000</li>
              <li>Premium: R 1 000 a month = R 12 000 annual premium.</li>
            </ul>
          </Row>      
        </Row>
        <Row>
          <H4Red className="mt-4">To qualify for SureThing, your business needs to meet the following criteria:</H4Red>
          <Row  style={{marginLeft: '1vw'}}>
            <ul className="pl-4 mt-3">
              <li>Turnover, revenue or fees must be less than R20m, and the business must have 20 employees or less.</li>
              <li>The business must be based in South Africa and looking only to insure South African operations.</li>
              <li>The business must consist of a single entity (no subsidiaries).</li>
              <li>The business should not process more than 100 000 personally identifiable records or unique debit or credit cards.</li>
              <li> There must be security, such as:</li>
              <ul>
                <li className="list-type-disc">Security patches and updates.</li>
                <li className="list-type-disc">Passwords that are changed regularly and are not easy to guess.</li>
                <li className="list-type-disc">Firewalls on a company network that restrict access to sensitive data.</li>
              </ul>
              <li>The business should be solvent: The directors and management must not have been the subject of any past/pending regulatory enquiry or investigation or have been dismissed or disqualified.</li>
              <li>Any audit reports must be unqualified and not have adverse findings.</li>
              <li>No retrenchments should be planned for the next 12 months.</li>
              <li>The business should have an internal or outsourced HR function.</li>
            </ul>
          </Row>      
        </Row>
        <Row>
          <H4Red className="mt-4">What’s excluded?</H4Red>
          <Row  style={{marginLeft: '1vw'}}>
            <ul className="pl-4 mt-3">
              <li>First-party losses: Direct financial loss and loss of business income suffered by the business itself.</li>
              <li>Product failure and product recall.</li>
              <li>Fines, penalties and punitive damages.</li>
              <li>Insolvency.</li>
              <li>Investment advice or performance.</li>
            
              <li>Sexual harassment, abuse and misconduct.</li>
              <li>Racism and hate speech.</li>
           
            </ul>
          </Row>      
        </Row>
       
      </Row>
      <BlackArrayText style={{ background: "#f9f9f9", marginTop: width >770 ? '40px' : '20px' }} link="/faq">
          [ See FAQs ]
        </BlackArrayText>

      <Row className="mt-5 align-items-center">
        <Col lg={4} className={(Style.fbutton1, `${
              width > 565 ? "justify-content-start" : "d-flex justify-content-center"
            }`)}>
          <BodyButton
            color="white"
            bg="rgb(218, 41, 28)"
            name="Get Cover Now"
            size={20}
            marginL={0}
            width={width > 770 && 180}
            weight={700}
            marginT={width > 770 ? 0 : 20}
            black={width > 770 ? false : true}
            link="/forms"
            id="fast-facts-cover-button"
          />
        </Col>
        <Col
          className={classNames(
            Style.money,
            `${
              width > 565 ? "justify-content-start" : "justify-content-center"
            }`
          )}
        >
         
          <div
            className={classNames(
              Style.money,
              `${
                width > 565 ? "justify-content-start" : "justify-content-center mt-3"
              }`
            )}
          >
            Premium: <span className="text-danger"> &nbsp;R 1 000 pm</span>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default FastFacts;
